import { abstractAutocompletes } from "./abstract-autocomplete";

export default function () {
    let tableElem = document.querySelector("#gs-program-assignment-edit-time-slot-table");
    if (tableElem != null) {
        tableElem.addEventListener("gs-add-more-new-row", function (e: CustomEvent) {
            abstractAutocompletes[0].addInputPipelineFromRow(e.detail);
        });
    }
}
